
import { Product } from "@/models/base";
import Vue from "vue";
import AppLabelLayoutSelect from "@/components/label-layout/LabelLayoutSelect.vue";
import AppStockLocationSelect from "@/components/StockLocationSelect.vue";
import { LabelLayoutService, ProductService } from "@/services";
import { LabelLayoutModel } from "@/models/label-layout/label-layout-model";

export default Vue.extend({
	data(){
		return {
			defaultLayoutId: 0,
			toUseStockLocationForQuantity: 0,
			isRunning: false
		};
	},
	props: {
		selectedItems: {
			type: Array as ()=>Product[],
			required: true
		}
	},
	computed: {
		valid():boolean {
			if (this.defaultLayoutId == 0) return false;
			if (this.toUseStockLocationForQuantity == 0) return false;
			return true;
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		// eslint-disable-next-line max-lines-per-function
		async confirm(){
			if (!this.valid) return;
			if (this.isRunning) return;
			this.isRunning = true;
			try{
				let items = [...this.selectedItems];
				let defaultLayout = await LabelLayoutService.getById(this.defaultLayoutId);
				let ids = items.map(i=>i.ID);
				let records = await ProductService.getProductsByIds(ids, {preloads: ["LabelSettings"]});
				let groups:{layout:LabelLayoutModel, items:Product[]}[] = [];
				for (let record of records) {
					if (!record.LabelSettings) continue;
					let found = false;
					let layoutId = record.LabelSettings.getLabelLayoutIdOfLocation(this.toUseStockLocationForQuantity);
					if (layoutId == 0){
						layoutId = defaultLayout.ID;
					}
					for (let group of groups) {
						if (group.layout.ID != layoutId) continue;
						group.items.push(record);
						found = true;
						break;
					}
					if (found) {
						continue;
					}
					let layout = defaultLayout;
					if (layoutId != 0) {
						layout = await LabelLayoutService.getById(layoutId);
					}
					groups.push({layout, items: [record]});
				}
				for (let group of groups){
					await this.printLabels(group.layout, group.items);
				}
				let text = this.$ct("confrim-create-automatic-labels-successfull");
				let confirm = await this.$wf.confirm(text, this.$ct("common.yes"), this.$ct("common.no"), this.$ct("common.attention"), "info");
				if (!confirm) return;
				await ProductService.removeToPrintLabels(ids, this.toUseStockLocationForQuantity);
				this.close();
			}catch(err){

			}finally{
				this.isRunning = false;
			}
		},
		async printLabels(layout:LabelLayoutModel, items:Product[]){
			layout = await LabelLayoutService.getById(layout.ID);
			if (!layout.Data) return;
			if (layout.Data.Data.Preloads.length > 0) {
				let ids = items.map(i=>i.ID);
				items = await ProductService.getProductsByIds(ids,{preloads: [...layout.Data.Data.Preloads, "LabelSettings"]});
			}
			let toPrintRecords = [];
			for (let record of items){
				if (!record.LabelSettings) continue;
				let toPrintCount = record.LabelSettings.getAmountInLocation(this.toUseStockLocationForQuantity);
				for (let i = 0; i < toPrintCount; i++) {
					toPrintRecords.push(record);
				}
			}
			layout.Data.Data.print(toPrintRecords, layout, 1);
		},
	},
	components: {
		AppLabelLayoutSelect,
		AppStockLocationSelect
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
